


document.addEventListener('StartAsyncLoading',function(event){
document.querySelectorAll('.video-wrapper').forEach((ele) => {
    ele.querySelector('video').load();
});
});

document.querySelectorAll('.video-wrapper').forEach((ele) => {
    //console.log(ele);
    ele.addEventListener('click', function() {
        if(this.classList.contains('is-playing')) {    
        this.querySelector('video').pause();
        }
        else {
        document.querySelectorAll('.video-wrapper').forEach((ele) => {
            ele.querySelector('video').pause();
        });
        this.classList.add('is-playing');
        this.querySelector('video').play();
        }
    })
    ele.querySelector('video').addEventListener('ended', function() {
        this.closest('.video-wrapper').classList.remove('is-playing');
    })
    ele.querySelector('video').addEventListener('pause', function() {
        //console.log(this);
        this.closest('.video-wrapper').classList.remove('is-playing');
    })
})